import { render } from "./Hard.vue?vue&type=template&id=3b5a1596"
import script from "./Hard.vue?vue&type=script&lang=js"
export * from "./Hard.vue?vue&type=script&lang=js"

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__